import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { jwtDecode } from 'jwt-decode'
import { User } from './usersSlice'
import $api from '../api'
import { Howl, Howler } from 'howler'
import { Song } from './songsSlice'
import { getSongUrl } from '../tools'
import { RootState } from './store'

interface State {
  // queue?: Song[]
  queue?: Song[]
}

export const initialState: State = {}
export const attemptPlaySong = createAsyncThunk<Song[], Song>(
  'app/play-song',
  async (song, { getState }) => {
    return [song]
  },
)

export const appReducer = createSlice({
  name: 'app',
  initialState,
  reducers: {
    logout: () => {
      // Handled in store.ts in rootReducer
    },
  },
  extraReducers: (builder) => {
    builder.addCase(attemptPlaySong.fulfilled, (state, { payload }) => {
      state.queue = payload
    })
  },
})

export const { logout } = appReducer.actions
export default appReducer.reducer
